import { defineMessages } from "react-intl";

export const fileMessages = defineMessages({
    file: {
        id: "admin.work-order-details.attachments-table.file-name-header",
        defaultMessage: "File",
        description: "File name table column header",
    },
    uploadedOn: {
        id: "admin.work-order-details.attachments-table.uploaded-on-header",
        defaultMessage: "Uploaded on",
        description: "Uploaded on table column header",
    },
    uploadedBy: {
        id: "admin.work-order-details.attachments-table.uploaded-by-header",
        defaultMessage: "Uploaded by",
        description: "Uploaded by table column header",
    },
    type: {
        id: "admin.work-order-details.attachments-table.type-header",
        defaultMessage: "Type",
        description: "Type table column header",
    },
    description: {
        id: "admin.work-order-details.attachments-table.description-header",
        defaultMessage: "Description",
        description: "Description table column header",
    },
    addFiles: {
        id: "admin.work-order-details.attachments-table.add-files-btn",
        defaultMessage: "Add files",
        description: "Add files button for attachments table",
    },
    uploadFiles: {
        id: "admin.work-order-details.attachments-table.upload-files-btn",
        defaultMessage: "Upload files",
        description: "Upload files button for attachments table",
    },
    videoError: {
        id: "admin.work-order-details.attachments-table.video-error",
        defaultMessage: "Videos are not supported",
        description: "Videos are not supported error message",
    },
    NoAcceptableFileError: {
        id: "admin.work-order-details.attachments-table.non-acceptable-file-error",
        defaultMessage: "Only valid files are supported",
        description: "Only valid files are supported",
    },
    launchSketchTools: {
        id: "attachments.launch-sketch-tool",
    },
    fileSizeLimit: {
        id: "admin.work-order-details.attachments-table.file-upload-limit",
        defaultMessage: "File upload limit exceeded. MaxLimit = {size}",
        description: "File size limit",
    },
    fileTooLargeError: {
        id: "admin.work-order-details.attachments-table.file-size-exceeded-error",
        defaultMessage: "File is too large. Max size = {size}",
        description: "File too large error message",
    },
    fileExtensionError: {
        id: "admin.work-order-details.attachments-table.file-extension-error",
        defaultMessage: "File type is not supported",
        description: "File extension error message",
    },
});
